<template>
  <main-content>
    <kt-panel>
      <div class="create-services">
        <router-link to="/online-factor/create-discount">
          <button class="btn btn-success">ایجاد کد تخفیف</button>
        </router-link>
        <router-link to="/factors" class="mr-2">
          <button class="btn btn-success">بازگشت</button>
        </router-link>
      </div>
      <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card online-factor-search-bar" style="overflow:inherit">
          <div class="card-header bg-transparent" id="headingOne">
            <div class="card-title collapsed" data-toggle="collapse"
                 data-target="#filterForm"
                 aria-controls="filterForm">
              {{ $t('label.search') }}
            </div>
          </div>
          <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
            <div class="card-body">
              <form class="w-100" @submit.prevent="filterAction($event, query)">
                <kt-form-section>
                  <kt-form-row>
                    <kt-col xs="12" sm="6" md="4">
                      <kt-form-group>
                        <kt-form-label for="title">
                          {{ $t('online-factor.discount_code')}}
                        </kt-form-label>
                        <kt-form-control
                            ref="title"
                            name="title"
                            id="title"
                            v-model="query.code"/>
                      </kt-form-group>
                    </kt-col>
                  </kt-form-row>
                </kt-form-section>
                <kt-form-section class="text-left">
                  <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                </kt-form-section>
              </form>
            </div>
          </div>
        </div>
      </div>
    </kt-panel>
    <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
  </main-content>
</template>

<script>
import mainContent from '@/components/main-content.vue';
import { ShopApiUrl } from '@/common/api.service';
import { AuthorizationHeader } from '@/common/jwt.service';
import columns from '@/views/online-factor/datatable/columns_discounts';
import actionsColumn from '@/views/online-factor/components/actions-column-discounts.vue';

export default {
  name: 'Discounts',
  components:{
    'main-content': mainContent,
  },
  computed: {
    datatableProps() {
      return {
        id: 'datatable',
        data: {
          type: 'remote',
          source: {
            read: {
              url: ShopApiUrl.path('factor/discounts'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: function(res) {
                return res.data.data
              },
              params: this.query,
            }
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {
        },
        pagination: false,
        sortable: true,
        columns: columns,
        actions: actionsColumn
      }
    },
  },
  data() {
    return {
      query: {}
    }
  },
  methods: {
    filterAction(e, query) {
      this.query = query;
      if (this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload();
      }
    }
  }
};
</script>

<style scoped>
.create-services {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
}
</style>